module.exports = __webpack_public_path__ + "img/back_38.f7058cc7.svg";